import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom'
import { PorscheDesignSystemProvider } from '@porsche-design-system/components-react';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('pag-rating')!);

root.render(
  <Router>
    <PorscheDesignSystemProvider>
      <App />
    </PorscheDesignSystemProvider>
  </Router>
);